let obj = {
    channelTypeOptions:[
        // {
        //     text: '专业代理',
        //     value: '1'
        // },
        // {
        //     text: '专业经纪',
        //     value: '2'
        // },
        // {
        //     text: '兼业渠道(有资质)',
        //     value: '3'
        // },
        // {
        //     text: '兼业渠道(无资质)',
        //     value: '4'
        // },
        // {
        //     text: '内部用户',
        //     value: '5'
        // },
        {
            text: '保险经纪',
            value: '6'
        },
        {
            text: '保险代理',
            value: '7'
        },
        {
            text: '自媒工作室',
            value: '8'
        },
        {
            text: '旅行社',
            value: '9'
        },
        {
            text: '科技公司',
            value: '10'
        },
        {
            text: '其他',
            value: '11'
        },
    ],
    cporpaOption:[
        {
            text: '企业',
            value: '1'
        },
        {
            text: '个人',
            value: '2'
        },
    ]
}

export default obj